export const LEADERS_PAGE_SIZE = 12;
export const ASSESSMENT_PAGE_SIZE = 12;
export const FOLDER_PAGE_SIZE = 30;

export const ASSESSMENT_COMMON = {
  logoPath: '/assets/images/TLC-Logo.svg',
  logoAlt: 'TLC Logo',
  showTopDivider: true,
};
